import React from 'react';
import { Tr } from 'Shared/components/i18n/Tr';
import { WpLink } from 'Wpds/components/link';
import { WpText } from 'Wpds/components/text';
import { WpBadge } from 'Wpds/components/badge';

export function TrExamples() {
  return (
    <>
      {/* Named placeholder with mixed content:
       * examples.json: "perform.tr_examples.named_placeholder": "Click <link>here</link> for more details."
       */}
      <br />
      <br />
      <Tr trKey="perform.tr_examples.named_placeholder" components={{ link: <a href="/help/more" /> }} />
      <br />
      <br />
      {/* With params in plain text:
       * examples.json: "perform.tr_examples.with_params": "Hello {0}, good {1}."
       */}
      <Tr trKey="perform.tr_examples.with_params" params={['Jonathan', 'afternoon']} />
      <br />
      <br />
      {/* Named placeholder with params in plain text:
       * examples.json: "perform.tr_examples.with_params": Hello <a>{0}</a>, good {1}"
       */}
      <Tr
        trKey="perform.tr_examples.component_with_params"
        params={['Jonathan', 'afternoon']}
        components={{
          a: p => <strong>{p.children}</strong>,
        }}
      />
      <br />
      <br />
      {/* Nested components:
       * examples.json: "perform.goals.examples.nested": "<a>Important <d>NEW</d>:</a> read <b>this guide</b> <c>now</c> <e></e>."
       */}
      <Tr
        trKey="perform.goals.examples.nested"
        params={['testing interpolation']}
        components={{
          a: p => (
            <WpText noMargin bold tag="span">
              {p.children}
            </WpText>
          ),
          b: p => <WpLink href="/help/important">{p.children}</WpLink>,
          c: p => <WpBadge className="badge">{p.children}</WpBadge>,
          d: p => <WpBadge color="green">{p.children}</WpBadge>,
        }}
      />
    </>
  );
}
